export default __webpack_public_path__ + "static/media/settings.c521ff92.svg";